var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#translate';
                    var viewUrl = 'svg/icons.svg#view-translate';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };